// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"columns_wrapper__FzoBB","colums-3":"columns_colums-3__5deUf"};